import AddBeneficiaryError from './AddBeneficiaryError';
class TotalPercentageExceeded extends AddBeneficiaryError {
    constructor(options) {
        super('The investor has exceeded the total beneficiary percentage', options);
    }
}
export default TotalPercentageExceeded;
